<template>
  <div class="all">
    <div class="enterprisetop">
      <div style="float:left;height:100%;width:22%;border-right:1px solid #ccc;background: #F9FAFC;">
        <el-tooltip class="item"
                    effect="light"
                    content="企业账号"
                    placement="top">
          <div class="companyid">
            {{ dataForm.userName }}
          </div>
        </el-tooltip>
        <div class="company">
          企业账号
        </div>
        <div class="allcompany">
          <el-tooltip class="item"
                      effect="light"
                      content="中控技术股份有限公司 (默认)"
                      placement="top">
            <div style="font-weight:bold">中控技术股份有限公司 (默认)</div>
          </el-tooltip>
          <el-tooltip class="item"
                      effect="light"
                      content="中控技术股份有限公司 (默认)123123123123"
                      placement="top">
            <div>中控技术股份有限公司 (默认)123123123123</div>
          </el-tooltip>
          <el-tooltip class="item"
                      effect="light"
                      content="浙江中控西子技术股份有限公司"
                      placement="top">
            <div>浙江中控西子技术股份有限公司</div>
          </el-tooltip>
          <el-tooltip class="item"
                      effect="light"
                      content="浙江中控西子技术股份有限公司"
                      placement="top">
            <div>浙江中控西子技术股份有限公司</div>
          </el-tooltip>
        </div>
      </div>
      <div class="secondtable">
        <div>用户ID</div>
        <div>{{ dataForm.custId }}</div>
        <div>姓名</div>
        <div>{{ dataForm.name }}</div>
        <div>注册时间</div>
        <div>{{ dataForm.registTime }}</div>
        <div>注册端</div>
        <div>{{ dataForm.registClient }}</div>
        <div>注册渠道</div>
        <div>{{ dataForm.registChannel }}</div>
      </div>
      <div class="thirdtable">
        <div>账号类型</div>
        <div>{{ dataForm.accountMode }}</div>
        <!-- todo -->
        <div>是否认证</div>
        <div>已认证 ：企业客户、渠道商 </div>
        <div>权限详情</div>
        <div>中控技术>权限详情</div>
        <div>角色</div>
        <div>管理员</div>
        <div>组织</div>
        <div>X部>XX 部>XXX部</div>
      </div>
    </div>
    <div class="statistics">
      <div style="float:left">统计信息</div>
      <div style="float:right;cursor:pointer;color:blue">更多<i class="el-icon-d-arrow-right"></i></div>
    </div>
    <el-table :data="statisticsTable"
              border
              style="width: 100%">
      <el-table-column prop="jine"
                       label="消费金额">
      </el-table-column>
      <el-table-column prop="shuliang"
                       label="订单数量">
      </el-table-column>
      <el-table-column prop="youhui"
                       label="优惠券（张）">
      </el-table-column>
      <el-table-column prop="yufu"
                       label="收藏商品">
      </el-table-column>
      <el-table-column prop="daifu"
                       label="收藏资料">
      </el-table-column>
      <el-table-column prop="xinyong"
                       label="已购课程">
      </el-table-column>
      <el-table-column prop="pingjia"
                       label="评价">
      </el-table-column>
      <el-table-column prop="guanlian"
                       label="登录次数">
      </el-table-column>
    </el-table>
    <el-table :data="statisticsTable1"
              border
              style="width: 100%">
      <el-table-column prop="jine"
                       label="员工人数">
      </el-table-column>
      <el-table-column prop="shuliang"
                       label="SAAS服务">
      </el-table-column>
      <el-table-column prop="youhui"
                       label="收藏专题">
      </el-table-column>
      <el-table-column prop="yufu"
                       label="收藏课程">
      </el-table-column>
      <el-table-column prop="daifu"
                       label="关注解决方案">
      </el-table-column>
      <el-table-column prop=""
                       label="">
      </el-table-column>
      <el-table-column prop=""
                       label="">
      </el-table-column>
      <el-table-column prop=""
                       label="">
      </el-table-column>
    </el-table>
    <div class="collections">
      <div style="float:left">收款记录</div>
      <div style="float:right;cursor:pointer;color:blue">更多<i class="el-icon-d-arrow-right"></i></div>
    </div>
    <el-table :data="collectionsTable"
              border
              style="width: 100%">
      <el-table-column prop="zhangdan"
                       fixed
                       label="账单号">
      </el-table-column>
      <el-table-column prop="leixing"
                       label="账单类型">
      </el-table-column>
      <el-table-column prop="riqi"
                       label="账单日期">
      </el-table-column>
      <el-table-column prop="yingfu"
                       label="应付款">
      </el-table-column>
      <el-table-column prop="yishou"
                       label="已收款">
      </el-table-column>
    </el-table>
    <div class="enquiry">
      <div style="float:left">询价单记录</div>
      <div style="float:right;cursor:pointer;color:blue">更多<i class="el-icon-d-arrow-right"></i></div>
    </div>
    <el-table :data="enquiryTable"
              border
              style="width: 100%">
      <el-table-column prop="bianhao"
                       fixed
                       label="订单编号">
      </el-table-column>
      <el-table-column prop="tijiao"
                       label="提交时间">
      </el-table-column>
      <el-table-column prop="zhanghao"
                       label="用户账号">
      </el-table-column>
      <el-table-column prop="jine"
                       label="订单金额">
      </el-table-column>
      <el-table-column prop="zhifu"
                       label="支付方式">
      </el-table-column>
      <el-table-column prop="laiyuan"
                       label="订单来源">
      </el-table-column>
      <el-table-column prop="zhuangtai"
                       label="订单状态">
      </el-table-column>
      <el-table-column prop=""
                       label="操作">
        <template>
          <div>查看询价单</div>
        </template>
      </el-table-column>
    </el-table>
    <div class="orderform">
      <div style="float:left">订单记录</div>
      <div style="float:right;cursor:pointer;color:blue">更多<i class="el-icon-d-arrow-right"></i></div>
    </div>
    <el-table :data="orderformTable"
              border
              style="width: 100%">
      <el-table-column prop="bianhao"
                       fixed
                       label="订单编号">
      </el-table-column>
      <el-table-column prop="tijiao"
                       label="提交时间">
      </el-table-column>
      <el-table-column prop="zhanghao"
                       label="用户账号">
      </el-table-column>
      <el-table-column prop="jine"
                       label="订单金额">
      </el-table-column>
      <el-table-column prop="zhifu"
                       label="支付方式">
      </el-table-column>
      <el-table-column prop="laiyuan"
                       label="订单来源">
      </el-table-column>
      <el-table-column prop="zhuangtai"
                       label="订单状态">
      </el-table-column>
      <el-table-column prop=""
                       label="操作">
        <template>
          <div>查看订单</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataForm: {
        userName: '180000000',
        custId: 'CU20200923001', // 用户id
        name: '王小二', // 姓名
        registTime: '2017-07-24 17:25:38', // 注册时间
        registClient: 'PC端', // 注册端
        registChannel: '手机号注册（微信/QQ/OneLogin/Apple', // 注册渠道
        accountMode: '企业类型' // 账号类型
      },
      // 统计信息
      statisticsTable: [
        {
          jine: 1000,
          shuliang: 100,
          youhui: 20,
          yufu: 30000,
          daifu: 70000,
          xinyong: '15',
          pingjia: '15',
          guanlian: 20
        }
      ],
      statisticsTable1: [
        {
          jine: 1000,
          shuliang: 100,
          youhui: 20,
          yufu: 30000,
          daifu: 70000,
          xinyong: 15,
          pingjia: 100,
          guanlian: 100
        }
      ],
      // 收款记录
      collectionsTable: [
        {
          zhangdan: 'D20200923000120',
          leixing: '工程服务单',
          riqi: '2020-09-23 13:23:24',
          yingfu: '¥25010.00',
          yishou: '¥2500.00'
        },
        {
          zhangdan: 'D20200923000120',
          leixing: '工程服务单',
          riqi: '2020-09-23 13:23:24',
          yingfu: '¥2500.00',
          yishou: '¥2500.00'
        },
        {
          zhangdan: 'D202300923000120',
          leixing: '工程服务单',
          riqi: '2020-09-23 13:23:24',
          yingfu: '¥2500.00',
          yishou: '¥2500.00'
        },
        {
          zhangdan: 'D201200923000120',
          leixing: '工程服务单',
          riqi: '2020-09-23 13:23:24',
          yingfu: '¥2500.00',
          yishou: '¥2500.00'
        }
      ],
      // 询价列表
      enquiryTable: [
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2017-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥200.00', // 订单金额
          zhifu: '未支付', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        },
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2019-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥200.00', // 订单金额
          zhifu: '未支付', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        },
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2018-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥200.00', // 订单金额
          zhifu: '支付宝', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        },
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2017-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥2000.00', // 订单金额
          zhifu: '微信', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        }
      ],
      // 订单列表
      orderformTable: [
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2017-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥200.00', // 订单金额
          zhifu: '未支付', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        },
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2019-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥200.00', // 订单金额
          zhifu: '未支付', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        },
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2018-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥200.00', // 订单金额
          zhifu: '支付宝', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        },
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2017-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥2000.00', // 订单金额
          zhifu: '微信', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        }
      ]
    }
  },
  methods: {

  },
  components: {
  }
}
</script>
<style lang="scss" scoped="scoped">
.enterprisetop {
  width: 100%;
  height: 201px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}
.companyid {
  height: 30px;
  width: 70%;
  text-align: center;
  line-height: 30px;
  margin-left: 15%;
  margin-top: 5px;
}
.company {
  height: 30px;
  width: 70%;
  text-align: center;
  line-height: 30px;
  margin-left: 15%;
  border: 1px solid red;
  background: red;
  color: white;
  border-radius: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 10px;
  padding-right: 10px;
}
.allcompany {
  height: 140px;
  width: 100%;
  margin-top: 15px;
}
.allcompany div {
  width: 80%;
  margin-left: 10%;
  height: 20px;
  margin-top: 8px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  font-size: 12px;
}
.secondtable,
.thirdtable {
  float: left;
  width: 39%;
  height: 100%;
}
.secondtable div:nth-of-type(odd) {
  width: 30%;
  float: left;
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding-right: 10px;
  font-size: 12px;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  background: #f9fafc;
}
.secondtable div:nth-of-type(even) {
  width: 70%;
  float: left;
  height: 40px;
  line-height: 40px;
  text-align: left;
  padding-left: 10px;
  font-size: 12px;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
}
.thirdtable div:nth-of-type(odd) {
  width: 30%;
  float: left;
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding-right: 10px;
  font-size: 12px;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  background: #f9fafc;
}
.thirdtable div:nth-of-type(even) {
  width: 70%;
  float: left;
  height: 40px;
  line-height: 40px;
  text-align: left;
  padding-left: 10px;
  font-size: 12px;
  border-bottom: 1px solid #ccc;
}
.statistics,
.collections,
.enquiry,
.orderform {
  width: 100%;
  height: 35px;
  line-height: 35px;
}
</style>
